import script from "./CreatePasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./CreatePasswordModal.vue?vue&type=style&index=0&id=43ec1bc2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43ec1bc2"]])

export default __exports__